import { lazy } from "react";

const RELOAD_FLAG = "lazyChunkReloadedAt";
const RELOAD_COOLDOWN_MS = 10_000;

function isChunkLoadError(error) {
    if (!error) return false;
    const message = String(error.message || error);
    return (
        error.name === "ChunkLoadError" ||
        /Failed to fetch dynamically imported module/i.test(message) ||
        /Importing a module script failed/i.test(message) ||
        /error loading dynamically imported module/i.test(message)
    );
}

function reloadOnce() {
    try {
        const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
        if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;
        sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
    } catch (_) {
        // sessionStorage may be unavailable (private mode, storage disabled).
        // In that case skip the guard and still reload.
    }
    window.location.reload();
    return true;
}

export default function lazyWithReload(factory) {
    return lazy(() =>
        factory().catch((error) => {
            if (isChunkLoadError(error) && reloadOnce()) {
                return new Promise(() => {});
            }
            throw error;
        })
    );
}
